import axiosInstance from "../axiosInstance";
import type { ImportCourseDocumentResponse } from "./types";

export const importCourseDocument = async (
  file: File,
  onUploadProgress?: (progressEvent: { loaded: number; total?: number }) => void,
): Promise<ImportCourseDocumentResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post<ImportCourseDocumentResponse>(
    "/api/private/learning-center/courses/import-document",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 300000, // 5 minutes — AI processing can take several minutes for large documents
      onUploadProgress,
    },
  );

  return response.data;
};
